import * as React from 'react';

import { singleton } from 'logic/singleton';
import type DataLakeWidget from 'data-lake/logic/DataLakeWidget';

export type WidgetConfigurationContextValue = {
  widget: DataLakeWidget;
  setWidget: React.Dispatch<React.SetStateAction<DataLakeWidget>>;
  isLoading: boolean;
  resetWidget: () => void;
};

const WidgetConfigurationContext = React.createContext<WidgetConfigurationContextValue>(undefined);
export default singleton('contexts.WidgetConfigurationContext', () => WidgetConfigurationContext);
